const Icon1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 53 53" fill="none">
        <path d="M46.134 22.8667L35.2451 22.8667" stroke="#EAC280" strokeWidth="1.49333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M40.6895 17.4219L40.6895 28.3108" stroke="url(#paint0_linear_7442_10308)" strokeWidth="1.49333" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.4225 43.5555C37.4225 33.9335 30.5973 26.1333 22.178 26.1333C13.7588 26.1333 6.93359 33.9335 6.93359 43.5555"
            fill="#FDF6E8"
        />
        <path
            d="M37.4225 43.5555V44.3022C37.8349 44.3022 38.1691 43.9679 38.1691 43.5555H37.4225ZM6.93359 43.5555H6.18693C6.18693 43.9679 6.52122 44.3022 6.93359 44.3022V43.5555ZM37.4225 43.5555H38.1691C38.1691 33.6179 31.1002 25.3866 22.178 25.3866V26.1333V26.88C30.0944 26.88 36.6758 34.2491 36.6758 43.5555H37.4225ZM22.178 26.1333V25.3866C13.2559 25.3866 6.18693 33.6179 6.18693 43.5555H6.93359H7.68026C7.68026 34.2491 14.2617 26.88 22.178 26.88V26.1333ZM37.4225 43.5555V42.8089H6.93359V43.5555V44.3022H37.4225V43.5555Z"
            fill="url(#paint1_linear_7442_10308)"
        />
        <path
            d="M22.1779 26.1336C26.9889 26.1336 30.889 22.2336 30.889 17.4225C30.889 12.6115 26.9889 8.71143 22.1779 8.71143C17.3669 8.71143 13.4668 12.6115 13.4668 17.4225C13.4668 22.2336 17.3669 26.1336 22.1779 26.1336Z"
            fill="#FDF6E8"
            stroke="url(#paint2_linear_7442_10308)"
            strokeWidth="1.49333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <defs>
            <linearGradient id="paint0_linear_7442_10308" x1="41.1895" y1="17.4219" x2="41.1895" y2="28.3108" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F7D391" />
                <stop offset="1" stopColor="#DAAB69" />
            </linearGradient>
            <linearGradient id="paint1_linear_7442_10308" x1="22.178" y1="26.1333" x2="22.178" y2="43.5555" gradientUnits="userSpaceOnUse">
                <stop stopColor="#E8BF7D" />
                <stop offset="1" stopColor="#D19F5D" />
            </linearGradient>
            <linearGradient id="paint2_linear_7442_10308" x1="22.1779" y1="8.71143" x2="22.1779" y2="26.1336" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F9D694" />
                <stop offset="1" stopColor="#E7BE7C" />
            </linearGradient>
        </defs>
    </svg>
);

const Icon2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 43 43" fill="none">
        <ellipse cx="19.4661" cy="19.5856" rx="18.2522" ry="18.2522" fill="#FDF6E8" stroke="url(#paint0_linear_7793_615)" strokeWidth="1.49333" />
        <path
            d="M5.97949 14.8098H16.9896M5.97949 26.0348H16.9896M22.0712 14.8098H33.0813M5.97949 20.574H16.9896M22.0712 26.4249V21.3363C22.0712 20.9153 22.4503 20.574 22.9181 20.574H33.0813"
            stroke="#E7BD7C"
            strokeWidth="1.49333"
            strokeLinecap="round"
        />
        <path
            d="M24.5762 36.1421L24.4941 33.2941C24.4941 33.0363 24.7031 32.8274 24.9608 32.8274H40.9395C41.3445 32.8274 41.6757 33.1502 41.686 33.5551L41.7511 36.1218C41.7603 36.4837 41.5086 36.8001 41.1538 36.8724L37.2613 37.6657C37.2122 37.6757 37.1622 37.6807 37.1122 37.6807H29.8128C29.7681 37.6807 29.7236 37.6767 29.6797 37.6688L25.1895 36.8553C24.8422 36.7924 24.5864 36.4949 24.5762 36.1421Z"
            fill="#FDF6E8"
        />
        <path
            d="M24.4941 39.3189V37.1207C24.4941 36.8114 24.7449 36.5607 25.0541 36.5607H40.9208C41.3332 36.5607 41.6675 36.895 41.6675 37.3073V39.3346C41.6675 39.6787 41.4324 39.9782 41.0982 40.0599L37.1753 41.0193C37.1173 41.0335 37.0577 41.0407 36.9979 41.0407H29.7264C29.673 41.0407 29.6199 41.035 29.5677 41.0236L25.0822 40.0485C24.739 39.9739 24.4941 39.6701 24.4941 39.3189Z"
            fill="#FDF6E8"
        />
        <path
            d="M33.0814 34.168C37.8925 34.168 41.7927 33.0846 41.7927 31.7482C41.7927 30.4118 37.8925 29.3284 33.0814 29.3284C28.2703 29.3284 24.3701 30.4118 24.3701 31.7482C24.3701 33.0846 28.2703 34.168 33.0814 34.168Z"
            fill="#FDF6E8"
            stroke="#D2A160"
            strokeWidth="1.49333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.3701 35.1357C24.3701 36.7394 28.2703 38.0395 33.0814 38.0395C37.8925 38.0395 41.7927 36.7394 41.7927 35.1357"
            stroke="#D2A160"
            strokeWidth="1.49333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M24.3701 39.0073C24.3701 40.611 28.2703 41.9111 33.0814 41.9111C37.8925 41.9111 41.7927 40.611 41.7927 39.0073"
            stroke="#D2A160"
            strokeWidth="1.49333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M41.793 31.264V39.0074" stroke="#D2A160" strokeWidth="1.49333" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M24.3701 31.264V39.0074" stroke="#D2A160" strokeWidth="1.49333" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
            <linearGradient id="paint0_linear_7793_615" x1="19.4661" y1="1.33337" x2="19.4661" y2="37.8378" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FCDA98" />
                <stop offset="1" stopColor="#CF9D5B" />
            </linearGradient>
        </defs>
    </svg>
);

const Icon3 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 41 36" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.79467 10.6688L29.5942 0.995329C29.9792 0.838841 30.4179 1.02683 30.5701 1.41353L34.2136 10.6688M0.893555 11.4155C0.893555 11.0031 1.22785 10.6688 1.64022 10.6688H39.3469C39.7593 10.6688 40.0936 11.0031 40.0936 11.4155V16.643C37.1547 16.643 34.2136 18.6336 34.2136 22.1184C34.2136 25.6032 37.1547 28.5914 40.0936 28.5914V33.8189C40.0936 34.2313 39.7593 34.5656 39.3469 34.5656H1.64022C1.22785 34.5656 0.893555 34.2313 0.893555 33.8189V28.5914C3.83467 28.5914 6.77355 26.6007 6.77355 22.6172C6.77355 18.6336 3.83243 16.643 0.893555 16.643V11.4155ZM13.6324 20.0127H19.5147ZM13.6324 25.9869H27.3547Z"
            fill="#FDF6E8"
        />
        <path
            d="M5.79467 10.6688L29.5942 0.995329C29.9792 0.838841 30.4179 1.02683 30.5701 1.41353L34.2136 10.6688M13.6324 20.0127H19.5147M13.6324 25.9869H27.3547M40.0936 16.643V11.4155C40.0936 11.0031 39.7593 10.6688 39.3469 10.6688H1.64022C1.22785 10.6688 0.893555 11.0031 0.893555 11.4155V16.643C3.83243 16.643 6.77355 18.6336 6.77355 22.6172C6.77355 26.6007 3.83467 28.5914 0.893555 28.5914V33.8189C0.893555 34.2313 1.22785 34.5656 1.64022 34.5656H39.3469C39.7593 34.5656 40.0936 34.2313 40.0936 33.8189V28.5914C37.1547 28.5914 34.2136 25.6032 34.2136 22.1184C34.2136 18.6336 37.1547 16.643 40.0936 16.643Z"
            stroke="url(#paint0_linear_7795_2169)"
            strokeWidth="1.49333"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <defs>
            <linearGradient id="paint0_linear_7795_2169" x1="37.9158" y1="10.3367" x2="7.42689" y2="33.2033" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FBD997" />
                <stop offset="0.625003" stopColor="#CC9856" />
                <stop offset="1" stopColor="#C28A48" />
            </linearGradient>
        </defs>
    </svg>
);

const Icon4 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 43 35" fill="none">
        <path
            d="M5.96548 32.6455L3.99351 15.555C3.91947 14.9134 4.6398 14.4868 5.16684 14.8601L12.7618 20.2399L21.0928 8.09049C21.3929 7.65277 22.0411 7.65916 22.3326 8.1027L30.3084 20.2399L37.5125 14.9152C38.0376 14.527 38.7729 14.9525 38.698 15.6012L36.7314 32.6455C36.6879 33.0222 36.3689 33.3066 35.9896 33.3066H6.70722C6.32796 33.3066 6.00895 33.0222 5.96548 32.6455Z"
            fill="#FDF6E8"
        />
        <path
            d="M12.7618 20.2399L21.2809 26.2742C21.544 26.4606 21.897 26.457 22.1563 26.2654L30.3084 20.2399M12.7618 20.2399L5.16684 14.8601C4.6398 14.4868 3.91947 14.9134 3.99351 15.555L5.96548 32.6455C6.00895 33.0222 6.32796 33.3066 6.70722 33.3066H35.9896C36.3689 33.3066 36.6879 33.0222 36.7314 32.6455L38.698 15.6012C38.7729 14.9525 38.0376 14.527 37.5125 14.9152L30.3084 20.2399M12.7618 20.2399L21.0928 8.09049C21.3929 7.65277 22.0411 7.65916 22.3326 8.1027L30.3084 20.2399"
            stroke="url(#paint0_linear_7795_7034)"
            strokeWidth="1.49333"
            strokeLinecap="round"
        />
        <circle cx="3.80169" cy="11.6533" r="2.98667" stroke="url(#paint1_linear_7795_7034)" strokeWidth="1.49333" />
        <circle cx="21.7216" cy="4.18658" r="2.98667" stroke="#F1CC8A" strokeWidth="1.49333" />
        <circle cx="38.8954" cy="11.6533" r="2.98667" stroke="url(#paint2_linear_7795_7034)" strokeWidth="1.49333" />
        <defs>
            <linearGradient id="paint0_linear_7795_7034" x1="21.3484" y1="7.17322" x2="21.3484" y2="33.3066" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F1CA88" />
                <stop offset="1" stopColor="#C7914F" />
            </linearGradient>
            <linearGradient id="paint1_linear_7795_7034" x1="3.80169" y1="7.91992" x2="3.80169" y2="15.3866" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F1CC8A" />
                <stop offset="1" stopColor="#E3B775" />
            </linearGradient>
            <linearGradient id="paint2_linear_7795_7034" x1="38.8954" y1="7.91992" x2="38.8954" y2="15.3866" gradientUnits="userSpaceOnUse">
                <stop stopColor="#F1CC8A" />
                <stop offset="1" stopColor="#E4B976" />
            </linearGradient>
        </defs>
    </svg>
);

const AskIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="7.55" stroke="black" strokeWidth="0.9" />
        <path
            d="M7.62695 10.9089C7.93645 10.909 8.20397 10.9763 8.41504 11.1111C8.61207 11.2459 8.72456 11.4197 8.72461 11.6316C8.72461 11.8435 8.61241 12.027 8.40137 12.1619C8.19027 12.2967 7.93653 12.364 7.62695 12.364C7.31732 12.364 7.06366 12.2869 6.85254 12.1521C6.6414 12.0172 6.54297 11.8435 6.54297 11.6316C6.54301 11.4197 6.64144 11.2459 6.85254 11.1111C7.06364 10.9763 7.31738 10.9089 7.62695 10.9089ZM8.1377 3.63647C8.96338 3.63647 9.6364 3.84747 10.1445 4.2937C10.6527 4.72759 10.9072 5.32266 10.9072 6.07886C10.9072 6.69842 10.7422 7.20667 10.4375 7.60327C10.3232 7.72723 9.95442 8.06216 9.34473 8.58276C9.11606 8.76871 8.95027 8.97974 8.83594 9.20288C8.70904 9.45069 8.64551 9.71119 8.64551 10.0085V10.1824H7.18457V10.0085C7.18457 9.53747 7.2616 9.12841 7.43945 8.7937C7.60461 8.45899 8.10007 7.93848 8.92578 7.21948L9.07812 7.04565C9.30662 6.77307 9.42081 6.47551 9.4209 6.16577C9.4209 5.75668 9.29409 5.43354 9.06543 5.198C8.82408 4.96249 8.4807 4.85133 8.04883 4.85132C7.49001 4.85132 7.09587 5.0122 6.85449 5.35913C6.63853 5.64425 6.53711 6.05429 6.53711 6.57495H5.08887C5.08887 5.6576 5.35609 4.93839 5.91504 4.41772C6.46128 3.89713 7.1977 3.63647 8.1377 3.63647Z"
            fill="#03060B"
        />
    </svg>
);

export { Icon1, Icon2, Icon3, Icon4, AskIcon };
